import { PlaybackState } from "../types";

interface Props {
  playbackState: PlaybackState;
}

export default function GameTitle({ playbackState }: Props) {
  if (playbackState === "mix") {
    return (
      <span>
        Listening to <span className={"text-purple-400"}>Your Mix</span>
      </span>
    );
  }

  return (
    <span>
      Listening to the <span className={"text-purple-400"}>Reference</span>
    </span>
  );
}
